import Config from '@config';
import { ReferenceBook } from '@gasbi/shared';

import { injectSupplySlice } from '@/app/supplyApi';
import { FiltersGrid, Pagination } from '@/features/types';
import {
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@/features/utils';

export const contactPersonPositionsApi = injectSupplySlice({
  baseUrl: `${Config.VITE_API_URL}/contact-person-positions`,
  tagTypes: ['ContactPersonPosition'],
  endpoints: builder => ({
    getContactPersonPositions: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: () => ['ContactPersonPosition'],
    }),
    getContactPersonPositionsPaginated: builder.infiniteQuery<
      ReferenceBook[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['ContactPersonPosition'],
    }),
    getContactPersonPositionById: builder.query<ReferenceBook, string>({
      query: id => ({ url: `/${id}`, method: 'GET' }),
      providesTags: (_result, _error, id) => [
        { type: 'ContactPersonPosition', id },
      ],
    }),
    createContactPersonPosition: builder.mutation<
      string,
      Pick<ReferenceBook, 'value'>
    >({
      query: data => ({ url: '', method: 'POST', data }),
      invalidatesTags: ['ContactPersonPosition'],
    }),
    updateContactPersonPosition: builder.mutation<
      void,
      { id: string; data: Omit<ReferenceBook, 'id'> }
    >({
      query: ({ id, data }) => ({ url: `/${id}`, method: 'PUT', data }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'ContactPersonPosition', id },
        'ContactPersonPosition',
      ],
    }),
  }),
});

export const {
  useGetContactPersonPositionsQuery,
  useGetContactPersonPositionByIdQuery,
  useCreateContactPersonPositionMutation,
  useUpdateContactPersonPositionMutation,
} = contactPersonPositionsApi;

export const useGetContactPersonPositionsInfiniteQuery =
  normalizeInfiniteQueryData(
    contactPersonPositionsApi.useGetContactPersonPositionsPaginatedInfiniteQuery,
  );
